import { scope } from "../../../exports/debug";
import type { Expand } from "../../nexus/utils/utils.types";

export type ObjectToEntry<T> = Expand<{ [P in keyof T]: [P, T[P]] }[keyof T]>;

/**
 *
 */
export type ObjectToEntries<T> = ObjectToEntry<T>[];

/**
 *
 */
export const asyncScope = scope("gr.navigation");

/**
 *
 *
 */
export const NAV_META = "__nav_meta__";

/**
 *
 *
 */
export const NAV_SCOPES = "__nav_scopes__";

/**
 *
 *
 *
 *
 *
 */
export const defaultEntryComparator = <T extends [string, unknown]>(a: T, b: T): boolean =>
  a[0] === b[0] && a[1] === b[1];

/**
 *
 */
export const locationAssign = location.assign.bind(location);
